import React from 'react';
import "./branding.css";
import { useNavigate } from 'react-router-dom';

function Branding() {

    const navigate = useNavigate()

    const handleclick = () => {
        navigate('/')
    }
  return (
    <div>
      <div class="branding-container">
  <div class="branding-wrapper">
    <div class="branding-content">
      <div class="branding-item">
        
        <h1>COMING SOON</h1>
        <p>This website is under construction.</p>


         <div
                    className="container d-flex justify-content-center my-4"
                    data-aos="fade-up"
                    data-aos-delay="1000"
                >
                    <button className="btn-15" onClick={handleclick}>
                       Go to Home Page
                    </button>
                </div>
      </div>
    </div>
  </div>
</div>

    </div>
  )
}

export default Branding
